export const projectStates = Object.freeze({
  'po.navtopbar.selectall': 1,
  'po.navtopbar.selectactive': 2,
  'po.navtopbar.selectinactive': 3,
  'po.navtopbar.selectallarchived': 4,
});

export const clientProjectStates = Object.freeze({
  'po.navtopbar.selectall': 1,
  'po.navtopbar.selectactive': 2,
  'po.navtopbar.selectinactive': 3,
});

export const projectOrder = Object.freeze({
  'Most recent': 1,
  'Creation date': 2,
});
